<template>
    <!-- 订单管理/派对订单 -->
    <div class="party-order">
        <content-view v-show="$utils.renderWhen(this,'partyOrder')">
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="订单号">
                        <a-input placeholder="请输入" v-decorator="['id']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="客户名称">
                        <a-input placeholder="请输入" v-decorator="['customerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="客户手机号">
                        <a-input placeholder="请输入" v-decorator="['customerPhone']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="派对门店">
                        <a-select allowClear :options="shopList" placeholder="请选择" v-decorator="['shopId']" @select="search"></a-select>
                    </a-form-item>
                    <a-form-item label="派对日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['partyDate']"
                            @cahnge="search"
                        />
                    </a-form-item>
                    <a-form-item label="派对负责人">
                        <a-input placeholder="请输入" v-decorator="['partyStaff']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="派对类型">
                        <a-select allowClear :options="$commonOptions.partyTypeOpitons" placeholder="请选择" v-decorator="['partyType']" @select="search"></a-select>
                    </a-form-item>
                    <a-form-item label="订单状态">
                        <a-select allowClear :options="$commonOptions.partyOrderStatusOpitons" placeholder="请选择" v-decorator="['status']" @select="search"></a-select>
                    </a-form-item>
                    <a-form-item label="创建日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['createTime']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary" :loading="t_loading">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <template slot="extra">
                    <a-button v-if="getBtnByAuth('adminCreatePartyOrder')" type="primary" @click="toCreate">
                        <a-icon type="plus" />
                        新建
                    </a-button>
                    <a-button v-if="getBtnByAuth('adminPartyOrderisRepairCollection')" type="primary" @click="openCollection(true)">补收款</a-button>
                    <a-button v-if="getBtnByAuth('adminPartyOrderisRepairRefund')" type="primary" @click="openRefund(true)">补退款</a-button>
                </template>
                <a-table
                bordered
                :loading="t_loading"
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :row-selection="{ type: 'radio', getCheckboxProps, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :rowKey="(record, index) => index"
                >
                    <span slot="isEmpty" slot-scope="key">{{key | isEmpty}}</span>
                    <span slot="myToFixed2" slot-scope="key">{{key | myToFixed2 | thousandFormat}}</span>
                    <span slot="status" slot-scope="key">{{key | partyOrderStatus}}</span>
                    <span slot="action" slot-scope="a, row">
                        <template v-if="getBtnByAuth('adminPartyOrderCollection')">
                            <a class="text-primary" v-if="row.status === 1" @click="openCollection(false, row.id)">
                                收款
                            </a>
                            <span class="text-disabled" v-else>收款</span>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('adminPartyOrderRefund')">
                            <a class="text-primary" v-if="row.status === 1 && Boolean(row.hasProceedsAndCreate)" @click="openRefund(false, row.id)">
                                退款
                            </a>
                            <span class="text-disabled" v-else>退款</span>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('adminPartyOrderFile')">
                            <a class="text-primary" v-if="row.status === 1 && Boolean(row.hasProceedsAndCreate)" @click="openFile(row.id)">
                                归档
                            </a>
                            <span class="text-disabled" v-else>归档</span>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('adminPartyOrderCancel')">
                            <a class="text-primary" v-if="row.status === 1 && !Boolean(row.hasProceedsAndCreate)" @click="openCancel(row.id)">
                                取消
                            </a>
                            <span class="text-disabled" v-else>取消</span>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('adminPartyOrderEdit')">
                            <a class="text-primary" v-if="row.status === 1 && row.timeOut" @click="toEdit(row.id)">
                                编辑
                            </a>
                            <span class="text-disabled" v-else>编辑</span>
                            <a-divider type="vertical"/>
                        </template>
                        <a class="text-primary" v-if="getBtnByAuth('adminPartyOrderDefault')" @click="toDetail(row.id)">
                            详情
                        </a>
                        <span class="text-disabled" v-else>详情</span>
                    </span>
                </a-table>
            </a-card>
            <party-order-collection ref="partyOrderCollection" @cancel="getList" />
            <party-order-refund ref="partyOrderRefund" @cancel="getList" />
            <party-order-file @cancel="getList" ref="partyOrderFile" />
            <party-order-cancel @cancel="getList" ref="partyOrderCancel" />
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import partyOrderCollection from "@/components/modules/order/party-order-collection.component";
    import partyOrderRefund from "@/components/modules/order/party-order-refund.component";
    import partyOrderFile from "@/components/modules/order/party-order-file.component";
    import partyOrderCancel from "@/components/modules/order/party-order-cancel.component";
    const columns = [
    {
        title: "订单号",
        dataIndex: "id"
    },
    {
        title: "客户名称",
        dataIndex: "customerName"
    },
    {
        title: "客户手机号",
        dataIndex: "customerPhone"
    },
    {
        title: "派对门店",
        dataIndex: "shopName"
    },
    {
        title: "派对人数",
        dataIndex: "totalNum"
    },
    {
        title: "派对日期",
        dataIndex: "partyDate"
    },
    {
        title: "派对负责人",
        dataIndex: "partyStaff"
    },
    {
        title: "派对类型",
        dataIndex: "partyType"
    },
    {
        title: "状态",
        dataIndex: "status",
        scopedSlots: { customRender: "status" }
    },
    {
        title: "预售金额",
        dataIndex: "totalPresell",
        scopedSlots: { customRender: "myToFixed2" }
    },
    {
        title: "实收金额",
        dataIndex: "payment",
        scopedSlots: { customRender: "myToFixed2" }
    },
    {
        title: "创建时间",
        dataIndex: "createTime"
    },
    {
        title: "操作",
        key: "action",
        width: 200,
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "partyOrder",
        components: {
            partyOrderCollection,
            partyOrderRefund,
            partyOrderFile,
            partyOrderCancel
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                detailData: {},
                orderData: {},
                total: 0,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                t_loading: false,
                currentOrderId: null,
                currentOrderItem: {},
                selectedRowKeys: []
                
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
        },
        methods: {
            getCheckboxProps(row) {
                return {
                    props: {
                        disabled: row.status !== 1
                    }
                }
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
                        i.label = i.name;
                        i.value = i.id;
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        return;
                    }
                });
            },
            // 获取订单列表
            getList() {
                this.filterForm.validateFields((err, values) => {
                    if (err || this.t_loading) return;
                    if(values.orderId && values.orderId.length > 19) {
                        this.$message.warning('订单号不能超过19位，请重新输入')
                        return false
                    }
                    let partyDate = values['partyDate'] ? values['partyDate'] : [];
                    values.partyStartDate = partyDate.length > 0 ? partyDate[0].format('YYYY-MM-DD') : undefined;
                    values.partyEndDate = partyDate.length > 0 ? partyDate[1].format('YYYY-MM-DD') : undefined;

                    let createTime = values['createTime'] ? values['createTime'] : [];
                    values.createStartTime = createTime.length > 0 ? createTime[0].format('YYYY-MM-DD') : undefined;
                    values.createEndTime = createTime.length > 0 ? createTime[1].format('YYYY-MM-DD') : undefined;

                    delete values.partyDate;
                    delete values.createTime;
                    this.t_loading = true;
                    this.selectedRowKeys = [];
                    this.$api.order.partyOrderPage({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        // res.list.forEach(i => {
                            // i.isTimeout = this.$moment() <= this.$moment(i.partyDate + ' 23:59:59');
                        // });
                        this.pagination.total = res.total;
                        this.dataSource = res.list || [];
                        this.t_loading = false;
                    }).catch(err => {
                        this.t_loading = false;
                    })
                });
            },
            /**
             * @func toCreate 跳转创建
             */
            toCreate() {
                this.$router.push({name: 'createPartyOrder'});
            },
            /**
             * @func openCollection 打开收款弹窗
             */
            openCollection(isRepair, orderId) {
                if (isRepair) {
                    if (this.selectedRowKeys.length === 0) {
                        this.$message.error('请先选择一条数据操作补收款');
                        return false;
                    }
                    let status = this.currentOrderItem.status;
                    if (status !== 1) {
                        this.$message.error('此订单状态不是未归档');
                        return false;
                    }
                    let hasProceedsAndCreate = this.currentOrderItem.hasProceedsAndCreate;
                }
                if (Boolean(orderId)) {
                    this.currentOrderId = orderId;
                }
                this.$refs.partyOrderCollection.open(isRepair, this.currentOrderId);
            },
            /**
             * @func openRefund 打开退款弹窗
             */
            openRefund(isRepair, orderId) {
                if (isRepair) {
                    if (this.selectedRowKeys.length === 0) {
                        this.$message.error('请先选择一条数据操作补退款');
                        return false;
                    }
                    let status = this.currentOrderItem.status;
                    let hasProceedsAndCreate = this.currentOrderItem.hasProceedsAndCreate;
                    if (status !== 1) {
                        this.$message.error('此订单状态不是未归档');
                        return false;
                    }
                    if (!Boolean(hasProceedsAndCreate)) {
                        this.$message.error('此订单没有收款记录');
                        return false;
                    }
                }
                if (Boolean(orderId)) {
                    this.currentOrderId = orderId;
                }
                this.$refs.partyOrderRefund.open(isRepair, this.currentOrderId);
            },
            /**
             * @func openCancel 打开取消弹窗
             */
            openCancel(orderId) {
                this.$refs.partyOrderCancel.open(orderId);
            },
            /**
             * @func openFile 打开归档弹窗
             */
            openFile(id) {
                this.$refs.partyOrderFile.open(id);
            },
            /**
             * @func toEdit 跳转编辑
             */
            toEdit(orderId) {
                this.$router.push({name: 'editPartyOrder', params: { orderId }});
            },
            /**
             * @func toDetail 跳转详情
             */
            toDetail(orderId) {
                this.$router.push({name: 'partyOrderDetail', params: { orderId }});
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                this.currentOrderId = selectedRows[0].id;
                this.currentOrderItem = selectedRows[0];
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        created() {},
        mounted() {
            setTimeout(() => {
                this.getShopList();
                this.getList();
            }, 500);
        },
        watch: {
            '$route'(val) {
                val.name == 'partyOrder' && this.getList();
            },
            'shopId'(val) {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>